// src\api\axios.js
import axios from 'axios'
const API_BASE_URL = import.meta.env.VITE_API_URL;

const api = axios.create({
	baseURL: API_BASE_URL,
	timeout: 100000,
	headers: {
		'Content-Type': 'application/json'
	}
})

// Если в будущем потребуется токен — можно подключить interceptor
// api.interceptors.request.use(config => {
//     config.headers.Authorization = `Bearer ${token}`;
//     return config;
// });

export default api
